<div
  class="catalog-menu"
  (mouseleave)="onMouseLeave()"
>
  <ul class="catalog-menu-top-level">
    @for (topLevelCategory of categories(); track topLevelCategory.i; let i = $index) {
      <li
        class="catalog-menu-top-level-item"
        [class.catalog-menu-top-level-item-active]="activeCategoryIndex() === i"
        (mouseenter)="setActiveIndex(i)"
      >
        <div class="catalog-menu-top-level-link-wrap">
          <a
            class="catalog-menu-top-level-link g-main-link"
            [routerLink]="['/', topLevelCategory.s]"
            routerLinkWithLang
          >
            {{ topLevelCategory.n }}
          </a>
          @if (topLevelCategory.c.length) {
            <i class="mbi mbi-ios-arrow-right catalog-menu-top-level-arrow"></i>
          }
        </div>
      </li>
    }
  </ul>

  @if (categories() && categories()[activeCategoryIndex()]?.c?.length) {
    <ul class="catalog-menu-second-level">
      @for (secondLevelCategory of categories()[activeCategoryIndex()].c; track secondLevelCategory.i; let i = $index) {
        <li class="catalog-menu-second-level-item">
          <a
            class="catalog-menu-second-level-link g-main-link"
            [routerLink]="['/', secondLevelCategory.s]"
            routerLinkWithLang
          >
            {{ secondLevelCategory.n }}
          </a>
          @if (secondLevelCategory.c.length) {
            <ul class="catalog-menu-third-level">
              @for (thirdLevelCategory of secondLevelCategory.c; track thirdLevelCategory.i) {
                <li class="catalog-menu-third-level-item">
                  <a
                    class="catalog-menu-third-level-link g-main-link"
                    [routerLink]="['/', thirdLevelCategory.s]"
                    routerLinkWithLang
                  >
                    {{ thirdLevelCategory.n }}
                  </a>
                </li>
              }
            </ul>
          }
        </li>
      }
    </ul>
  }

  @if (categories() && categories()[activeCategoryIndex()]?.m) {
    <img
      class="catalog-menu-second-level-img"
      [src]="categories()[activeCategoryIndex()].m"
      [alt]="categories()[activeCategoryIndex()].n"
    >
  }
</div>
